<template>
	<div class="modal modal--platform-special j-popup showing">
		<div class="modal__card modal__card--large">
			<button class="remove-btn remove-btn--white modal__close j-hide-popup" aria-label="Закрыть"></button>
			<template v-if="current_company === 'academy-learn-to-manage-finance'">
				<img src="../../../static/images/maraphones/academy-learn-to-manage-finance-popup.png" class="modal__plsp-img" width="100%" alt="">
			</template>
			<template v-else>
				<img src="../../../static/images/maraphones/academy-setup-operating-system-business-banner-3.png" class="modal__plsp-img" width="100%" alt="">
			</template>
			<a
				@click="sendEvent('https://eduson.academy/platform-special', 'request_full_course_buy_now')"
			 	class="modal__plsp-btn large-btn white-btn j-upd-additional-info j-hide-popup"
				:data-url="upd_additional_info_path"
				:data-additional-info="`platform-special-${current_company}-08-25`"
			>
				Оставить заявку
			</a>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: 'PlatformSpecialPopup',

	props: {
		current_company: {
			type: String,
			required: true
		},
		events_url: {
			type: String,
			required: true
		},
		current_user_id: {
			type: Number,
			required: false
		},
		current_company_id: {
			type: Number,
			required: false
		},
		upd_additional_info_path: {
			type: String,
			default: ''
		}
	},

	data() {
		return {

		}
	},

	methods: {
		sendEvent(redirect_url, event_name) {
			axios.request({
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"X-CSRF-Token": document
						.querySelector('meta[name="csrf-token"]')
						.getAttribute("content"),
				},
				url: this.events_url,
				method: "POST",
				data: {
					name: event_name,
					description: "Запрос из курса: " + this.current_company,
					user_id: this.current_user_id,
					eventable_type: "Company",
					eventable_id: this.current_company_id,
					redirect_url: redirect_url
				}
			}).then((response) => {
				window.location.href = redirect_url;
			})
		},
	}
}
</script>

<style>
.modal__plsp-img {
	display: block;
	width: 100%;
	border-radius: 5px;
}

.modal__plsp-btn {
	position: absolute;
	bottom: 60px;
	left: calc(50% - 103px);
}
</style>
